<template>
  <div class="layout-container">
    <TopBar />
    <div class="content-container">
      <transition name="sidebar-slide">
        <N2nSideBar v-if="showSidebar && sidebarStore.isOpen" />
      </transition>
      <main class="main-content" :class="{ 'full-width': !showSidebar || !sidebarStore.isOpen }">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useSidebarStore } from '../components/common/sidebar';
import TopBar from '../components/layout/TopBar.vue';
import N2nSideBar from '../components/layout/N2nSideBar.vue';

export default {
  name: 'N2nLayout',
  components: {
    TopBar,
    N2nSideBar
  },
  setup() {
    const route = useRoute();
    const sidebarStore = useSidebarStore();

    const showSidebar = computed(() => route.meta.module === 'n2n');

    return {
      showSidebar,
      sidebarStore
    };
  }
};
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
}

.content-container {
  display: flex;
  flex: 1;
  margin-top: 64px;
}

.main-content {
  flex: 1;
  padding: 10px;
  margin-left: 220px;
  height: calc(100vh - 64px);
  height: calc(100dvh - 64px);
  overflow: auto;
  box-sizing: border-box;
  transition: margin-left 0.3s ease;
}

.main-content.full-width {
  margin-left: 0;
}

@media (max-width: 1200px) {
  .main-content {
    padding-bottom: 24px;
    -webkit-overflow-scrolling: touch;
  }
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: all 0.3s ease;
}

.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(-100%);
}
</style>

